<template>
    <div>
        <el-form
            ref="addform"
            :inline="true"
            :model="addform"
            :rules="addrules"
            label-width="120px"
        >
            <el-form-item label="客户编号" prop="cnumber">
                <el-input v-model="addform.cnumber" style="width: 240px"/>
            </el-form-item>
            <el-form-item label="客户名称" prop="cname">
                <el-input maxlength="20" v-model="addform.cname" style="width: 240px" />
            </el-form-item>
            <el-form-item label="客户类别">
                <el-select
                    ref="selectReport"
                    v-model="addform.typeName"
                    placeholder="请选择客户类别"
                    style="width: 240px"
                >
                    <el-option
                        :value="addform.category"
                        :label="addform.typeName"
                        style="
                            width: 240px;
                            height: 200px;
                            overflow: auto;
                            background-color: #fff;
                        "
                    >
                        <el-tree
                            ref="tree"
                            :data="all"
                            :props="defaultProps"
                            node-key="id"
                            :default-expanded-keys="[0]"
                            @node-click="handleNodeClick"
                        />
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="电话">
                <el-input
                    v-model="addform.phone"
                    style="width: 240px"
                    @change="setAccount"
                />
            </el-form-item>
            <el-form-item label="客户等级">
                <el-select
                    v-model="addform.rank"
                    placeholder="请选择客户等级"
                    filterable
                    allow-create
                    default-first-option
                    style="width: 240px"
                >
                    <el-option
                        v-for="item in levels"
                        :key="item.value"
                        :label="item.label"
                        :value="item.label"
                    />
                </el-select>
            </el-form-item>
            <el-form-item label="签约时间">
                <el-date-picker
                    v-model="addform.signdate"
                    type="daterange"
                    value-format="yyyy-MM-dd"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    style="width: 240px"
                    :editable="false"
                    @change="dataPick"
                />
            </el-form-item>
            <el-form-item label="期初款(元)">
                <el-input v-model="addform.beginBill" type="number" :min="0" style="width: 240px" @input="$common.checkMoney($event,addform,'beginBill')"/>
            </el-form-item>
            <el-form-item label="所属公司">
                <el-input
                    v-model="addform.company"
                    disabled
                    style="width: 240px"
                />
            </el-form-item>
            <el-form-item label="销售人员">
                <el-input
                    v-model="addform.saleName"
                    placeholder="当前登录用户"
                    disabled
                    style="width: 240px"
                />
            </el-form-item>
            <el-divider />
            <el-form-item label="账号">
                <el-input
                    v-model="addform.username"
                    style="width: 240px"
                />
                <el-button type="text" style="margin-left: 30px" @click="resetPassword()"
                    >重置密码</el-button
                >
            </el-form-item>
            <el-form-item label="账号状态" style="display: block">
                <el-radio v-model="addform.valid" :label="1">开通</el-radio>
                <el-radio v-model="addform.valid" :label="0">禁用</el-radio>
            </el-form-item>
            <el-divider />
            <el-form-item label="开户名称">
                <el-input maxlength="100" v-model="addform.invoice" style="width: 240px" />
            </el-form-item>
            <el-form-item label="纳税人识别号">
                <el-input
                    v-model="addform.taxIdentification"
                    maxlength="50"
                    style="width: 240px"
                />
            </el-form-item>
            <el-form-item label="地址">
                <el-input
                    v-model="addform.invoiceaddress"
                    maxlength="80"
                    style="width: 240px"
                />
            </el-form-item>
            <el-form-item label="电话">
                <el-input maxlength="20" v-model="addform.invoicephone" style="width: 240px" />
            </el-form-item>
            <el-form-item label="开户银行">
                <el-input maxlength="50" v-model="addform.bankname" style="width: 240px" />
            </el-form-item>
            <el-form-item label="银行账号">
                <el-input
                    v-model="addform.bankaccountnumber"
                    style="width: 240px"
                     maxlength="50"
                />
            </el-form-item>
            <el-divider />
            <el-table
                :data="addform.list"
                border
                style="width: 100%"
                max-height="280px"
                :header-cell-style="{ background: '#eef1f6' }"
            >
                <el-table-column label="操作" width="100" align="center">
                    <template slot-scope="scope">
                        <el-button
                            size="mini"
                            icon="el-icon-plus"
                            circle
                            @click="additem(scope.$index, addform.list)"
                        />
                        <el-button
                            size="mini"
                            icon="el-icon-minus"
                            type="danger"
                            circle
                            @click="delitem(scope.$index, addform.list)"
                        />
                    </template>
                </el-table-column>
                <el-table-column label="联系人">
                    <template slot-scope="scope">
                        <el-input maxlength="30" v-model="scope.row.name" size="small" />
                    </template>
                </el-table-column>
                <el-table-column label="手机">
                    <template slot-scope="scope">
                        <el-input maxlength="20" v-model="scope.row.phone" size="small" />
                    </template>
                </el-table-column>
                <el-table-column label="QQ">
                    <template slot-scope="scope">
                        <el-input maxlength="20" v-model="scope.row.qq" size="small" />
                    </template>
                </el-table-column>
                <el-table-column label="微信">
                    <template slot-scope="scope">
                        <el-input maxlength="20" v-model="scope.row.wechat" size="small" />
                    </template>
                </el-table-column>
                <el-table-column label="货运" v-if="$global.useinstall!=1">
                    <template slot-scope="scope">
                        <el-select v-model="scope.row.transport" filterable allow-create value-key="id">
						    <el-option v-for="item in transList" :key="item.id" :label="item.label" :value="item"></el-option>
					    </el-select>
                    </template>
                </el-table-column>
                <el-table-column label="联系地址" width="240">
                    <template slot-scope="scope">
                        <el-cascader
                            ref="district"
                            v-model="scope.row.label"
                            size="mini"
                            :options="options_"
                            placeholder="省市区"
                            style="width: 100%"
                            @change="handleChange(scope.row)"
                        />
                        <el-input
                            v-model="scope.row.address"
                            size="small"
                            maxlength="50"
                            placeholder="详细地址"
                            style="width: 100%"
                        />
                    </template>
                </el-table-column>
                <el-table-column label="是否默认" width="108">
                    <template slot-scope="{ row }">
                        <el-switch
                            v-model="row.main"
                            :active-value="1"
                            :inactive-value="0"
                            @change="setMain(row)"
                        />
                    </template>
                </el-table-column>
            </el-table>
            <el-table
            :data="showList"
            border
            style="width: 100%;margin-top:20px"
            max-height="280px"
            :header-cell-style="{ background: '#eef1f6' }" 
            v-if="$global.useinstall==1&&false">
            <el-table-column align="center" width="120">
                <template #header>
                    <span style="padding-right:4px">操作</span>
                    <el-button
                        size="mini"
                        icon="el-icon-plus"
                        circle
                        @click="addRow()"
                    />
                </template>
                <template slot-scope="scope">
                    <el-button
                        size="mini"
                        icon="el-icon-minus"
                        type="danger"
                        circle
                        @click="removeRow(scope.$index)"
                    />
                    <el-button
                        size="mini"
                        icon="el-icon-edit"
                        type="primary"
                        circle
                        @click="editRow(scope.$index)"
                    />
                </template>
            </el-table-column>
            <el-table-column label="安装地区">
                <template slot-scope="{row}">
                    <div>{{row.district.join("")}}</div>
                </template>
            </el-table-column>
            <el-table-column  label="详细地址" prop="address">
            </el-table-column>
            <el-table-column  label="默认项">
                <template slot-scope="scope">
                    <el-switch
                        v-model="scope.row.main"
                        :active-value="1"
                        :inactive-value="0"
                        active-color="#409EFF"
                        @change='mainChange($event,scope.$index)'
                        inactive-color="#DCDFE6">
                    </el-switch>
                </template>
            </el-table-column>
            </el-table>
            <el-pagination
                v-if="totalPage>10"
                style="padding-top:20px"
                @current-change="handleCurrentChange"
                :current-page.sync="currentPage"
                :page-size="10"
                background
                layout="prev, pager, next"
                :total="totalPage">
                </el-pagination>
            <el-input
                v-model="addform.remark"
                type="textarea"
                :rows="2"
                placeholder="添加备注信息"
                maxlength="150"
                show-word-limit
                style="width: 100%; padding-top: 20px"
            />
        </el-form>
    <el-dialog
        :visible.sync="dialogFormVisible"
        append-to-body
        width="60%"
        @close="closeDialog"
    >
        <template slot="title">
            <span style="padding-right:10px">{{editIndex==-1?'新增':'编辑'}}安装地址</span>
            <el-checkbox v-if="editIndex==-1" v-model="continuous" label="连续添加"/>
        </template>
        <el-form>
            <el-form-item label="安装地区" prop="label">
                <el-cascader
                    ref="district"
                    v-model="editForm.label"
                    :options="options_"
                    placeholder="省市区"
                    style="width: 240px"
                />
            </el-form-item>
            <el-form-item label="详细地址" prop="address">
                <el-input
                    v-model="editForm.address"
                    maxlength="50"
                    style="width: 240px"
                />
            </el-form-item>
            <el-form-item label="默认项" prop="main" v-if="editIndex==-1">
                <el-switch
                    v-model="editForm.main"
                    :active-value="1"
                    :inactive-value="0"
                    >
                </el-switch>
            </el-form-item>
            <div style="text-align:right">
                <el-button type="primary" @click="sure()">确定</el-button>
                <el-button @click="dialogFormVisible = false">关闭</el-button>
            </div>
        </el-form>
    </el-dialog>
    </div>
</template>

<script>
import { regionData, CodeToText, TextToCode } from "element-china-area-data";

export default {
    props: {
        cid: {
            type: Number,
            default: () => 0,
        },
    },
    data() {
        return {
            placeDialog: false,
            options: [],
            addrules: {
                cnumber: [
                    {
                        required: true,
                        message: "请输入客户编号",
                    },
                    {
                        min: 5,
                        max: 25,
                        message: "长度为 5-25 个字符",
                    },
                ],
                cname: [
                    {
                        required: true,
                        message: "请输入客户名称",
                        trigger: "blur",
                    },
                    {
                        max: 20,
                        message: "不超过20个字符",
                        trigger: "blur",
                    },
                ],
            },
            addform: {
                label:[],
                cnumber: "",
                cname: "",
                category: "",
                rank: "",
                signdate: "",
                start: "",
                end: "",
                beginBill: 0,
                company: "",
                saleName: "",
                username: "",
                valid: "0",
                invoice: "",
                taxIdentification: "",
                invoiceaddress: "",
                phone: "",
                invoicephone: "",
                bankname: "",
                bankaccountnumber: "",
                workAddressList:[],
                list:[],
                remark: "",
            },
            addDialog: false,
            formLabelWidth: "120px",
            levels: [],
            options_: regionData,
            all: [],
            defaultProps: {
                children: "children",
                label: "label",
                id: "1",
            },
            transList:[],
            continuous:false,
            editIndex:-1,
            editForm:{},
            dialogFormVisible:false,
            currentPage:1,
            totalPage:10,
            showList:[],
        };
    },
    created(){
        this.$api.getCustomerRanksSetting({}).then((res)=>{
            let data = res.data.data;
            this.levels = [];
            if(data!=null&&data.length>0){
                let index = 1;
                data.forEach(e=>{
                    this.levels.push({
                        value:index,
                        label:e,
                    })
                    index++;
                })
            }
        })
        this.$api.getInfoPostSingle('/mobile/customer/listTransport',{limit:-1}).then(res=>{
            if(res.data.code==1){
                res.data.data.forEach(e=>{
                    let obj = {
                        label:e.name+e.phone+e.district.join(''),
                        id:e.id,
                    }
                    this.transList.push(obj);
                })
            }
        }) 
    },
    mounted() {
        this.getType();
    },
    methods: {
        handleCurrentChange(e){
            this.showList = null;
            let key = (e-1)*10;
            this.showList = this.addform.workAddressList.slice(key,key+10);
        },
        mainChange(e,key){
            if(e==1){
                this.addform.workAddressList.forEach((e,index)=>{
                    if(key==index){
                        e.main = 1;
                    }else{
                        e.main = 0;
                    }
                })
            }
        },
        addRow(){
            this.editForm = {
                main:0,
                district:[],
                label:'',
                address:'',
            }
            this.editIndex = -1;
            this.dialogFormVisible = true;
        },
        editRow(index){
            let zindex = (this.currentPage-1)*10 +index;
            let item = this.addform.workAddressList[zindex];
            if(item){
                this.editForm = {
                    main:item.main,
                    district:[],
                    label:item.label,
                    address:item.address,
                }
                this.editIndex = zindex;
                this.dialogFormVisible = true;
            }
        },
        sure(){
            if(this.editForm.label.length<1){
                    this.$message.error('没有选择安装地址');
                    return;
                }
            if(this.editIndex==-1){
                this.editForm.district = [];
                this.editForm.district.push(CodeToText[this.editForm.label[0]]);
                this.editForm.district.push(CodeToText[this.editForm.label[1]]);
                this.editForm.district.push(CodeToText[this.editForm.label[2]]);
                if(this.editForm.main==1){
                    this.addform.workAddressList.forEach(e=>{
                        e.main = 0;
                    })
                }
                this.addform.workAddressList.push(this.editForm);
                if(this.showList.length<10){
                    this.showList.push(this.editForm);
                }
                this.totalPage = this.addform.workAddressList.length;
                this.$message.success('操作成功');
                if(this.continuous){
                    this.editForm = {
                        main:0,
                        district:[],
                        label:'',
                        address:'',
                    }
                }else{
                    this.dialogFormVisible = false;
                }
            }else{
                let item = this.addform.workAddressList[this.editIndex];
                item.district = [];
                item.district.push(CodeToText[this.editForm.label[0]]);
                item.district.push(CodeToText[this.editForm.label[1]]);
                item.district.push(CodeToText[this.editForm.label[2]]);
                item.label = this.editForm.label;
                item.address = this.editForm.address;
                this.dialogFormVisible = false;
            }
        },
        closeDialog(){
            this.dialogFormVisible = false;
            this.editIndex = -1;
            this.editForm = {};
        },
        removeRow(index){
            this.showList.splice(index,1);
            let zindex = (this.currentPage-1)*10 +index;
            this.addform.workAddressList.splice(zindex,1);
            this.totalPage = this.addform.workAddressList.length;
            this.handleCurrentChange(this.currentPage);
        },
        getInfo() {
            this.$api.customercustomerDetail({id: this.cid,}).then((res) => {
                    if (res.data.code == 1) {
                        this.addform = res.data.data;
                        this.addform.contact.map((item) => {
                            item.label = [];
                            if (item.district.length > 0) {
                                item.label.push(
                                    TextToCode[item.district[0]].code
                                );
                            }
                            if (item.district.length > 1) {
                                item.label.push(
                                    TextToCode[item.district[0]][
                                        item.district[1]
                                    ].code
                                );
                            }
                            if (item.district.length > 2) {
                                item.label.push(
                                    TextToCode[item.district[0]][
                                        item.district[1]
                                    ][item.district[2]].code
                                );
                            }
                        });
                        this.addform.workAddressList = [];
                        this.totalPage = this.addform.workAddress.length;
                        this.addform.workAddress.forEach(e=>{
                            e.label = [];
                            if (e.district.length > 0) {
                                e.label.push(
                                    TextToCode[e.district[0]].code
                                );
                            }
                            if (e.district.length > 1) {
                                e.label.push(
                                    TextToCode[e.district[0]][
                                        e.district[1]
                                    ].code
                                );
                            }
                            if (e.district.length > 2) {
                                e.label.push(
                                    TextToCode[e.district[0]][
                                        e.district[1]
                                    ][e.district[2]].code
                                );
                            }
                            this.addform.workAddressList.push(e);
                            if(this.showList.length<10){
                                this.showList.push(e);
                            }
                        })
                        this.addform.list = [];
                        if(this.addform.contact.length>0){
                            this.addform.contact.forEach(e=>{
                                if(e.transportId>0){
                                    let obj = {
                                        id:e.transportId,
                                        label:e.transport,
                                    }
                                    e.transport = obj;
                                }
                                this.addform.list.push(e);
                            })
                            this.addform.contact = [];
                        }
                        if (this.addform.category) {
                            this.$refs["tree"].setCurrentKey(
                                this.addform.category
                            );
                            var currentNode = this.$refs.tree.getCurrentNode();
                            this.addform.typeName = currentNode.label;
                        }
                        this.addform.company = this.addform.cmpName;
                        this.addform.saleName = this.addform.empName;
                        let tempdate = [];
                        tempdate.push(this.addform.start);
                        tempdate.push(this.addform.end);
                        this.$set(this.addform,'signdate',tempdate);
                    }
                });
        },
        getType() {
            this.$api.customergetCustomerClassify({}).then((res) => {
                if (res.data.code == 1) {
                    this.options = res.data.data;
                    this.all = [];
                    var all = {};
                    all.children = this.options;
                    all.id = 0;
                    all.label = "全部";
                    all.parent = -1;
                    this.all.push(all);
                    this.getInfo();
                }
            });
        },
        handleNodeClick(node) {
            this.addform.category = node.id;
            this.addform.typeName = node.label;
            this.$refs.selectReport.blur();
        },
        handleChange(value) {
            // console.log(value);
        },
        additem(index, rows) {
            rows.splice(index + 1, 0, {
                name: "",
                tel: "",
                phone: "",
                qq: "",
                wechat: "",
                transport: "",
                label: [],
                address: "",
                main: "",
            });
        },
        delitem(index, rows) {
            if (rows.length > 1) {
                rows.splice(index, 1);
            } else {
                rows.splice(index, 1, {
                    name: "",
                    phone: "",
                    qq: "",
                    wechat: "",
                    transport: "",
                    label: [],
                    address: "",
                    main: "",
                });
            }
        },
        submitForm(formName) {
            if(this.addform.phone.length>0){
                if(!this.$common.checkPhone(this.addform.phone)){
                    this.$notify({
                        message: "号码不正确",
                        type: "error",
                        duration: 1000,
                    });
                    return;
                }
            }
            for(let i in this.addform.list){
                let con = this.addform.list[i];
                if(con.name!=null&&con.name.length>0){
                    if(!this.$common.checkPhone(con.phone)){
                        this.$notify({
                            message: con.name+"号码不正确",
                            type: "error",
                            duration: 1000,
                        });
                        return;
                    }
                }
            }
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.addform.contacts = [];
                    if(this.addform.label){
                        this.addform.district = [];
                        this.addform.district.push(CodeToText[this.addform.label[0]]);
                        this.addform.district.push(CodeToText[this.addform.label[1]]);
                        this.addform.district.push(CodeToText[this.addform.label[2]]);
                        this.addform.district = this.addform.district.toString();
                        this.addform.label = this.addform.label.toString();
                    }
                    let arr = [];
                    this.addform.workAddressList.forEach(e=>{
                        if(e.label){
                            e.district = [];
                            e.district.push(CodeToText[e.label[0]]);
                            e.district.push(CodeToText[e.label[1]]);
                            e.district.push(CodeToText[e.label[2]]);
                            e.district = e.district.toString();
                            e.label = e.label.toString();
                            arr.push(e);
                        }
                    })
                    this.addform.list.map((item) => {
                        if (item.name && item.phone) {
                            if (item.label) {
                                item.district = [];
                                item.district.push(CodeToText[item.label[0]]);
                                item.district.push(CodeToText[item.label[1]]);
                                item.district.push(CodeToText[item.label[2]]);
                                item.district = item.district.toString();
                                item.label = item.label.toString();
                            }
                            let cc = {
                                address:item.address,
                                index:item.index,
                                district:item.district,
                                main:item.main?1:0,
                                name:item.name,
                                phone:item.phone,
                                qq:item.qq,
                                tel:item.tel,
                                wechat:item.wechat,
                            } 
                            if(typeof(item.transport)=='object'){
                                cc.transport=item.transport.label;
                                cc.transportId=item.transport.id;
                            }else{
                                cc.transport=item.transport;
                                cc.transportId="";
                            }
                            this.addform.contacts.push(cc);
                        }
                    });
                    this.addform.emp = this.addform.emp ? this.addform.emp : "";
                    this.addform.contacts = JSON.stringify(this.addform.contacts);
                    this.addform.workAddress = JSON.stringify(arr);
                    this.$api.customereditCustomer(this.addform).then((res) => {
                        this.$notify({
                            title: "修改信息",
                            message: "修改成功",
                            type: "success",
                            duration: 1000,
                        });
                        this.$emit("closeEdit");
                    });
                } else {
                    console.log("error submit!!");
                    return false;
                }
            });
        },
        dataPick() {
            console.log(this.addform);
            this.addform.start = this.addform.signdate[0];
            this.addform.end = this.addform.signdate[1];
        },
        resetPassword(){
            this.addform.password = 'a25175';
            this.$notify({
                title: "重置密码",
                message: "已重置，点击确认以完成",
                type: "success",
                duration: 2000,
            });
        },
        setAccount() {
            this.addform.username = this.addform.phone;
        },
        setMain(row) {
            var param = {
                id: row.id,
                main: row.main,
            };
            this.addform.list.forEach((item) => {
                if (item.id === row.id) item.main = row.main;
                else if (row.main == 1) item.main = 0;
            });
            /*customersetMainContact(param).then(res => {
				  this.getInfo()
				})*/
        },
    },
};
</script>